import React, { useEffect, useMemo, useState } from 'react';
import { pickBy } from 'lodash';
import Table from 'partial/components/Table';
import SearchBar from 'partial/components/input/SearchBar';
import Pagination from 'partial/components/Pagination';
import Button from 'partial/components/Button';
import { useModuleContext } from 'partial/wrappers/ModuleWrapper';
import { aclHelper } from 'helper';

import { useOpenUpdateMaskName } from './modals/UpdateMaskName';
import { useMaskNameList } from './hooks';

const INITIAL_STATE = {
  keyword: '',
  status: 'pending',
};

export function RequestContent() {
  const { setSubLabel } = useModuleContext();

  const openUpdateMaskName = useOpenUpdateMaskName();
  const [filter, setFilter] = useState(INITIAL_STATE);
  const [page, setPage] = useState({ page: '' });
  const payload = useMemo(
    () =>
      pickBy({
        ...filter,
        ...page,
      }),
    [filter, page],
  );

  useEffect(() => {
    setPage({ page: '' });
  }, [filter]);

  const [isLoading, list, meta] = useMaskNameList(payload);

  useEffect(() => {
    if (!meta) return;
    setSubLabel(
      meta?.total === 0
        ? ''
        : `Total of ${meta?.total} mask name request${
            meta?.total === 1 ? '' : 's'
          }`,
    );
    return () => setSubLabel('');
  }, [meta, setSubLabel]);

  const renderAction = (data) => (
    <div className="flex flex-col xl:flex-row gap-2 justify-end">
      <Button
        outline
        onClick={() => openUpdateMaskName({ ...data, action: 'reject' })}
        size="xxs"
        className="uppercase w-[150px] text-sm font-semibold tracking-wider"
      >
        disapprove
      </Button>
      <Button
        primary
        onClick={() => openUpdateMaskName({ ...data, action: 'approve' })}
        size="xxs"
        className="uppercase w-[150px] text-sm font-semibold tracking-wider"
      >
        approve
      </Button>
    </div>
  );

  const renderLoa = (data) => (
    <button type="button">
      <a
        href={data.url}
        target="_blank"
        rel="noreferrer noopener"
        className="text-primary font-semibold hover:underline"
      >
        {data.name}
      </a>
    </button>
  );

  const canUpdate = aclHelper('sender_name', 'u');

  const format = [
    { label: 'MASK', key: 'name' },
    { label: 'ORGANIZATION/USER', key: 'organization_name' },
    { label: 'DATE REQUESTED', key: 'subscribed_at' },
    { label: 'DATE APPROVED', key: 'approved_at' },
    { label: 'EXPIRY DATE', key: 'expired_at' },
    {
      id: 'loa',
      key: (data) => renderLoa(data?.form_upload_url),
      label: 'LOA FORM',
    },
    ...(canUpdate
      ? [
          {
            id: 'action',
            key: (data) => renderAction(data),
            labelClassName: 'px-5 md:!px-8 whitespace-nowrap justify-center',
            contentClassName: 'pr-8 whitespace-nowrap text-right',
            label: 'ACTION',
          },
        ]
      : []),
  ];

  return (
    <section className="p-6 bg-white drop-shadow rounded-lg h-full flex flex-col">
      <div className="mb-5 flex items-center space-x-5">
        <SearchBar
          name="keyword"
          value={filter.keyword}
          onChange={setFilter}
          inputClassName="py-[1.05rem] "
        />
      </div>
      <div className="flex flex-col gap-10 min-h-[65vh]">
        <Table isLoading={isLoading} data={list} format={format} />
        <Pagination value={meta} onChange={setPage} />
      </div>
    </section>
  );
}

export default RequestContent;
